export const PARIS_LANDMARKS = [
  {
    id: 1,
    name: "蒙马特高地",
    need: 0,
    desc: "新手起点，艺术与灵感的开始。",
  },
  {
    id: 2,
    name: "塞纳河畔",
    need: 1,
    desc: "日落与法语朗读声交织，是学习节奏逐渐稳定的象征。",
  },
  {
    id: 3,
    name: "巴黎圣母院",
    need: 2,
    desc: "庄重与历史感并存，代表学习进入更深层的文化理解。",
  },
  {
    id: 4,
    name: "卢浮宫",
    need: 3,
    desc: "艺术与历史的宝库，象征词汇理解能力逐渐丰富。",
  },
  {
    id: 5,
    name: "凡尔赛宫",
    need: 4,
    desc: "秩序、华丽与体系感，代表知识结构正在成形。",
  },
  {
    id: 6,
    name: "香榭丽舍大街",
    need: 5,
    desc: "繁华与法式优雅并存，象征学习自信的建立。",
  },
  {
    id: 7,
    name: "埃菲尔铁塔",
    need: 6,
    desc: "巴黎之心，为长期坚持的学习者而点亮。",
  },
];